







































































































































import {Component} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import ScrollButton from "@/components/ScrollButton.vue";
import {LongTextWings} from '@/components';
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import {BlacklistContactItem} from "@/store/blacklists/types";
import ImportContacts from "@/components/BlackLists/ImportContacts.vue";
import {notifyDelete, notifyError} from "@/utils/notify-helper";
import BlackListContactsFilter from "@/components/BlackLists/BlackListContactsFilter.vue";
import BlackListContactActions from "@/components/BlackLists/BlackListContactActions.vue";

@Component({components: {BlackListContactsFilter, BlackListContactActions, ImportContacts, LongTextWings, ScrollButton}})
export default class BlackListContacts extends BaseItemsPage<BlacklistContactItem>{
  @Getter("blacklistContacts") blacklistContactsResponse: any;
  @Action("getBlackListContacts") actionGetBlacklistContacts: any;
  @Action("exportBlackListContacts") actionExport: any;
  @Action("deleteBlackListContacts") actionDelete: any;
  private is_show_filter = false;
  private is_show_import = false;
  private is_show_actions = false;
  private recipientIds:(number|undefined)[] = [];
  currentSort = "id";
  currentSortOrder = "desc";
  tableFields = ['id', 'msisdn', 'email', 'comment',];

  getData(): any {
    return this.blacklistContactsResponse;
  }

  back(): void{
    this.$router.push('/black_list/group');
  }

  exportContacts(): void {
    try {
      this.actionExport(this.$route.params.id)
    } catch(error) {
      notifyError(error);
    }
  }

  onSelect(items:BlacklistContactItem[]):void {
    this.recipientIds = items.filter(i => i.id).map(i => i.id)
  }

  onRefresh() {
    // @ts-ignore
    this.$refs.filter.filtered()
  }
}
